// Perfil gestor: lê direto do localStorage para estar disponível de forma
// síncrona nos contexts, antes do state do AuthContext ser preenchido.

export function isGestor() {
  try {
    return !!JSON.parse(localStorage.getItem('CIUSER'))?.gestor;
  } catch (err) {
    return false;
  }
}

export function getUserId() {
  try {
    return JSON.parse(localStorage.getItem('CIUSER'))?.id;
  } catch (err) {
    return undefined;
  }
}

export function getVendaSelecionada() {
  return localStorage.getItem('CIVENDA');
}

export function setVendaSelecionada(id) {
  localStorage.setItem('CIVENDA', id);
}

export function clearVendaSelecionada() {
  localStorage.removeItem('CIVENDA');
}

// Gestor que ainda não abriu nenhuma venda: não está "dentro" de um estudante,
// então as travas por venda (inadimplência, primeiro login) não se aplicam.
export function isGestorSemVenda() {
  return isGestor() && !getVendaSelecionada();
}
